<template>
  <div>
    <div class="bb-position bb-list">
      <transition name="fade" appear>
        <loader-fly v-if="loaderRun"/>
      </transition>
      <div class="bb-list-header">
        <input
          class="bb-list-header__input bb-input"
          type="text"
          placeholder="New position"
          v-model="position.name"
          @keyup.enter="createPosition()"/>
        <custom-select class="bb-position-select"
                       @mousenter="errorDepartment = false"
                       :class="{'bb-position-select_error': errorDepartment}"
                       :list="departmentsTypes"
                       default-val="Select department"
                       styles="high"
                       ref="selectDepartment"
                       @setValue="setDepartment"/>
        <button class="bb-position__btn bb-button" type="submit" @click="createPosition()">Add</button>
      </div>
      <div class="bb-position-list bb-list-body">
        <div class="bb-position-list-item bb-list-body-item"
             :class="{'bb-list-body-item_active': activeEditClick === index}"
             v-for="(position, index) in positionsList"
             :key="position.id"
             @mouseenter="chooseItem(index)"
             @mouseleave="leaveItem()"
             @click.stop="activeEditClick !== index ? hide() : true"
             v-click-outside="hide">
          <template v-if="activeEditClick === index">
            <input class="bb-list-body-item__input-edit bb-list-body-item__input-edit_position"
                   v-model="editedPosition.name"
                   @click.stop
                   @keyup.enter="editPosition(position)"
                   v-autofocus>
            <div class="bb-list-body-item__select">
            <custom-select :list="departmentsTypes"
                           @click.stop
                           :default-val="getDepartment(position.department) || 'Select department'"
                           @setValue="setDepartment"/>
            </div>
          </template>
          <transition name="fade-form">
            <button class="bb-list-body-item__btn-save bb-list-body-item__btn-save_positions bb-button"
                    v-if="activeEditClick === index"
                    @click="editPosition(position)">
              Save
            </button>
          </transition>
          <template v-if="activeEditClick !== index">
            <span class="bb-list-body-item__title">{{position.name}}</span>
            <span class="bb-list-body-item__title bb-list-body-item__title_select">
              {{getDepartment(position.department) ? getDepartment(position.department).name : ''}}
            </span>
          </template>
            <div class="bb-position__toolbar">
              <transition name="fade-form">
              <Toolbar v-if="activeIndex === index && activeEditClick !== index"
                       :delete-index="deleteConfirmIndex"
                       :index="index"
                       :item="position"
                       type="positions"
                       :btn-add="true"
                       @btnAdd="openSettings"
                       @deleteOpen="deleteConfirmIndex = index"
                       @deleteClose=" deleteConfirmIndex = false"
                       @openEdit="activateEditFunc"
                       @deleteItem="deletePosition"/>
              </transition>
            </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <ModalWindow @close="closeSettings" v-if="openSettingsStatus">
        <SettingsKPI
          @edit="saveSettings"
          :editPosition="openSettingsStatus"
          :isPosition="isPosition"
        />
      </ModalWindow>
    </transition>
  </div>
</template>

<script>
import SettingsKPI from '@/components/Settings/PositionsList/Positions/SettingsKPI/SettingsKPI'
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import PositionApi from '@/api/PositionList/api'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import ClickOutside from 'vue-click-outside'
import Toolbar from '@/components/Main/Toolbar/Toolbar'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import {FOUNDER, CEO} from '@/constants/roles'
import _ from 'lodash'
import departmentsTypes from '@/constants/departmentsTypes'
import {departmentCategory} from '@/constants/departmentCategory'

export default {
  name: 'SettingsPositions',
  components: {
    LoaderFly,
    Toolbar,
    CustomSelect,
    ModalWindow,
    SettingsKPI
  },
  data () {
    return {
      errorDepartment: false,
      departmentsTypes: departmentsTypes,
      openSettingsStatus: false,
      loaderRun: false,
      activeIndex: false,
      deleteConfirmIndex: false,
      activeEditIndex: false,
      activeEditClick: false,
      openModalSettings: false,
      editedPosition: {
        name: ''
      },
      kpiSettings: {
        'percent80': 0,
        'percent100': 0,
        'bonusFromOneTillTwo': 0,
        'bonusFromTwoTillThree': 0,
        'bonusFromThreeTillFour': 0,
        'bonusMoreThenFour': 0,
        'maxBonus': 0,
        'kpi': false
      }
    }
  },
  computed: {
    isPosition () {
      const { department } = this.openSettingsStatus
      const { PROJECT_MANAGER } = departmentCategory
      return department === PROJECT_MANAGER
    },
    position () {
      return {
        name: '',
        company: this.activeCompany
      }
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    positionsList: {
      get () {
        return this.$store.getters.positionsList
      },
      set (data) {
        this.$store.dispatch('setPositionsList', data)
      }
    },
    departmentsList () {
      return this.$store.getters.departmentsList
    },
    activeCompany () {
      return this.$store.getters.activeCompany
    }
  },
  methods: {
    getDepartment (id) {
      return _.find(this.departmentsList, {id: id})
    },
    setDepartment (item) {
      this.editedPosition.department = item.id
      this.position.department = item.id
    },
    openSettings (item) {
      this.openSettingsStatus = item
    },
    closeSettings () {
      this.openSettingsStatus = false
    },
    activateEditFunc (index, item) {
      this.editedPosition.name = item.name
      this.activeEditIndex = index
      this.activeEditClick = index
    },
    createPosition () {
      this.errorDepartment = !this.position.department
      if (!this.position.name || !this.position.department) {
        return
      }
      Object.assign(this.position, this.kpiSettings)
      PositionApi.createPosition({position: this.position})
        .then((resp) => {
          this.positionsList.unshift(resp.data)
          this.position.name = ''
          this.$refs.selectDepartment.delActiveItem()
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    updatePositionList () {
      const { PROJECT_MANAGER } = departmentCategory
      this.positionsList.forEach((el) => {
        const { department } = el
        if (department !== PROJECT_MANAGER) return
        el.isExecutionDepartment = false
        el.executionQuota = 0
      })
    },
    saveSettings (settings) {
      this.updatePositionList()
      this.editPosition({
        id: this.openSettingsStatus.id,
        position: settings
      })
    },
    editPosition ({id, position = this.editedPosition}) {
      if (!position.name || !position.department) {
        return
      }
      const index = _.findIndex(this.positionsList, {id: id})
      PositionApi.editPosition(position, id)
        .then((resp) => {
          this.positionsList.splice(index, 1, resp.data)
          this.activeEditIndex = false
          this.closeSettings()
          this.hide()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    deletePosition (index, idPosition) {
      PositionApi.deletePosition(idPosition)
        .then(() => {
          this.positionsList.splice(index, 1)
          this.deleteConfirmIndex = false
        })
        .catch((err) => {
          console.error(err)
        })
    },
    chooseItem (index) {
      this.activeIndex = index
      this.activeEditIndex = index
    },
    leaveItem () {
      this.activeIndex = false
      this.deleteConfirmIndex = false
      this.activeEditIndex = false
    },
    getPositions () {
      this.loaderRun = true
      PositionApi.getPositions()
        .then((resp) => {
          this.positionsList = resp.data.positions
          this.loaderRun = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    hide () {
      this.activeEditIndex = false
      this.activeEditClick = false
    }
  },
  watch: {
    activeCompany () {
      if (this.userInfo.role === FOUNDER.id || this.userInfo.role === CEO.id) {
        this.getPositions()
      }
    }
  },
  beforeMount () {
    this.getPositions()
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bb-position {
    max-width: 667px;

    &-select {
      position: relative;
      line-height: 10px;
      font-size: 14px;
      margin-left: -10px;
      margin-right: 12px;
      height: 42px;

      &:after {
        content: '';
        position: absolute;
        left: -1px;
        top: -1px;
        width: 100%;
        height: 100%;
        border: 1px solid transparent;
        border-radius: 5px;
        pointer-events: none;
        transition: 0.3s;
      }

      &:before {
        content: 'mandatory field';
        color: $color-red-orange;
        font-size: 12px;
        line-height: 14px;
        text-transform: lowercase;
        position: absolute;
        right: 25px;
        top: 50%;
        margin-top: -7px;
        z-index: 1;
        opacity: 0;
        pointer-events: none;
        transition: 0.3s;
      }

      &_error {
        &:after {
          border: 1px solid $color-red-orange;
        }

        &:before {
          opacity: 1;
        }
      }
    }

    &__toolbar {
      width: 85px;
    }

    &__btn {
      width: 73px;
      padding: 13px 23px;
      text-transform: uppercase;
    }

    &-list {
      margin-top: 30px;

      &-item {
        display: flex;
        padding: 9px 23px 9px 12px;
        background-color: $color-white;

        &:hover {
          padding-left: 16px;
        }

        &:first-child {
          border-bottom-right-radius: 5px;
          border-bottom-left-radius: 5px;
        }

        &:last-child {
          border-top-right-radius: 5px;
          border-top-left-radius: 5px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Settings/PositionsList/Positions/Positions.vue